import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import styles from "./AnimatedMap.module.scss";
import { useGSAP } from "@gsap/react";

const AnimatedMapMobile = () => {
  const dotsBoardRed = useRef();
  const blackDots = useRef();
  const greenDots = useRef();

  useGSAP(() => {
    gsap.from(blackDots.current.children, {
      x: 100, // move the items up
      y: 160,
      opacity: 0, // start with 0 opacity
      stagger: 0.0015, // stagger the appearance of each item
      ease: "power2.out",
      duration: 1,
      delay: 0.5,
      scrollTrigger: {
        trigger: blackDots.current,
        start: "top 50%",
        toggleActions: "play none none none", // only play the animation once
      },
    });
    gsap.from(greenDots.current.children, {
      y: -60,
      opacity: 0, // start with 0 opacity
      stagger: 0.15, // stagger the appearance of each item
      ease: "power2.out",
      duration: 1,
      delay: 2,
      scrollTrigger: {
        trigger: blackDots.current,
        start: "top 50%",
        toggleActions: "play none none none", // only play the animation once
      },
    });
  });

  return (
    <svg
      className={styles.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1384.45 1000"
      ref={dotsBoardRed}
    >
      <g ref={blackDots}>
        <circle className={styles.black} cx="160.03" cy="24" r="8" />
        <circle className={styles.black} cx="188.03" cy="24" r="8" />
        <circle className={styles.black} cx="216.03" cy="24" r="8" />
        <circle className={styles.black} cx="244.03" cy="24" r="8" />
        <circle className={styles.black} cx="272.03" cy="24" r="8" />
        <circle className={styles.black} cx="300.03" cy="24" r="8" />
        <circle className={styles.black} cx="328.03" cy="24" r="8" />
        <circle className={styles.black} cx="356.03" cy="24" r="8" />
        <circle className={styles.black} cx="384.03" cy="24" r="8" />
        <circle className={styles.black} cx="412.03" cy="24" r="8" />
        <circle className={styles.black} cx="440.03" cy="24" r="8" />
        <circle className={styles.black} cx="468.03" cy="24" r="8" />
        <circle className={styles.black} cx="496.03" cy="24" r="8" />
        <circle className={styles.black} cx="104.03" cy="52" r="8" />
        <circle className={styles.black} cx="132.03" cy="52" r="8" />
        <circle className={styles.black} cx="160.03" cy="52" r="8" />
        <circle className={styles.black} cx="188.03" cy="52" r="8" />
        <circle className={styles.black} cx="216.03" cy="52" r="8" />
        <circle className={styles.black} cx="244.03" cy="52" r="8" />
        <circle className={styles.black} cx="272.03" cy="52" r="8" />
        <circle className={styles.black} cx="300.03" cy="52" r="8" />
        <circle className={styles.black} cx="328.03" cy="52" r="8" />
        <circle className={styles.black} cx="356.03" cy="52" r="8" />
        <circle className={styles.black} cx="384.03" cy="52" r="8" />
        <circle className={styles.black} cx="412.03" cy="52" r="8" />
        <circle className={styles.black} cx="440.03" cy="52" r="8" />
        <circle className={styles.black} cx="468.03" cy="52" r="8" />
        <circle className={styles.black} cx="496.03" cy="52" r="8" />
        <circle className={styles.black} cx="524.03" cy="52" r="8" />
        <circle className={styles.black} cx="720.03" cy="52" r="8" />
        <circle className={styles.black} cx="748.03" cy="52" r="8" />
        <circle className={styles.black} cx="860.03" cy="52" r="8" />
        <circle className={styles.black} cx="888.03" cy="52" r="8" />
        <circle className={styles.black} cx="916.03" cy="52" r="8" />
        <circle className={styles.black} cx="944.03" cy="52" r="8" />
        <circle className={styles.black} cx="1140.03" cy="52" r="8" />
        <circle className={styles.black} cx="20.03" cy="80" r="8" />
        <circle className={styles.black} cx="48.03" cy="80" r="8" />
        <circle className={styles.black} cx="76.03" cy="80" r="8" />
        <circle className={styles.black} cx="132.03" cy="80" r="8" />
        <circle className={styles.black} cx="160.03" cy="80" r="8" />
        <circle className={styles.black} cx="188.03" cy="80" r="8" />
        <circle className={styles.black} cx="244.03" cy="80" r="8" />
        <circle className={styles.black} cx="272.03" cy="80" r="8" />
        <circle className={styles.black} cx="300.03" cy="80" r="8" />
        <circle className={styles.black} cx="328.03" cy="80" r="8" />
        <circle className={styles.black} cx="356.03" cy="80" r="8" />
        <circle className={styles.black} cx="384.03" cy="80" r="8" />
        <circle className={styles.black} cx="412.03" cy="80" r="8" />
        <circle className={styles.black} cx="440.03" cy="80" r="8" />
        <circle className={styles.black} cx="468.03" cy="80" r="8" />
        <circle className={styles.black} cx="496.03" cy="80" r="8" />
        <circle className={styles.black} cx="692.03" cy="80" r="8" />
        <circle className={styles.black} cx="720.03" cy="80" r="8" />
        <circle className={styles.black} cx="748.03" cy="80" r="8" />
        <circle className={styles.black} cx="1168.03" cy="80" r="8" />
        <circle className={styles.black} cx="20.03" cy="108" r="8" />
        <circle className={styles.black} cx="48.03" cy="108" r="8" />
        <circle className={styles.black} cx="76.03" cy="108" r="8" />
        <circle className={styles.black} cx="104.03" cy="108" r="8" />
        <circle className={styles.black} cx="132.03" cy="108" r="8" />
        <circle className={styles.black} cx="244.03" cy="108" r="8" />
        <circle className={styles.black} cx="272.03" cy="108" r="8" />
        <circle className={styles.black} cx="300.03" cy="108" r="8" />
        <circle className={styles.black} cx="328.03" cy="108" r="8" />
        <circle className={styles.black} cx="356.03" cy="108" r="8" />
        <circle className={styles.black} cx="384.03" cy="108" r="8" />
        <circle className={styles.black} cx="412.03" cy="108" r="8" />
        <circle className={styles.black} cx="440.03" cy="108" r="8" />
        <circle className={styles.black} cx="468.03" cy="108" r="8" />
        <circle className={styles.black} cx="496.03" cy="108" r="8" />
        <circle className={styles.black} cx="944.03" cy="108" r="8" />
        <circle className={styles.black} cx="972.03" cy="108" r="8" />
        <circle className={styles.black} cx="1140.03" cy="108" r="8" />
        <circle className={styles.black} cx="1168.03" cy="108" r="8" />
        <circle className={styles.black} cx="1196.03" cy="108" r="8" />
        <circle className={styles.black} cx="1224.03" cy="108" r="8" />
        <circle className={styles.black} cx="1364.03" cy="108" r="8" />
        <circle className={styles.black} cx="20.03" cy="136" r="8" />
        <circle className={styles.black} cx="48.03" cy="136" r="8" />
        <circle className={styles.black} cx="76.03" cy="136" r="8" />
        <circle className={styles.black} cx="104.03" cy="136" r="8" />
        <circle className={styles.black} cx="132.03" cy="136" r="8" />
        <circle className={styles.black} cx="160.03" cy="136" r="8" />
        <circle className={styles.black} cx="188.03" cy="136" r="8" />
        <circle className={styles.black} cx="328.03" cy="136" r="8" />
        <circle className={styles.black} cx="356.03" cy="136" r="8" />
        <circle className={styles.black} cx="384.03" cy="136" r="8" />
        <circle className={styles.black} cx="412.03" cy="136" r="8" />
        <circle className={styles.black} cx="440.03" cy="136" r="8" />
        <circle className={styles.black} cx="468.03" cy="136" r="8" />
        <circle className={styles.black} cx="496.03" cy="136" r="8" />
        <circle className={styles.black} cx="916.03" cy="136" r="8" />
        <circle className={styles.black} cx="1000.03" cy="136" r="8" />
        <circle className={styles.black} cx="1056.03" cy="136" r="8" />
        <circle className={styles.black} cx="1084.03" cy="136" r="8" />
        <circle className={styles.black} cx="1112.03" cy="136" r="8" />
        <circle className={styles.black} cx="1140.03" cy="136" r="8" />
        <circle className={styles.black} cx="1168.03" cy="136" r="8" />
        <circle className={styles.black} cx="1196.03" cy="136" r="8" />
        <circle className={styles.black} cx="1224.03" cy="136" r="8" />
        <circle className={styles.black} cx="1252.03" cy="136" r="8" />
        <circle className={styles.black} cx="1280.03" cy="136" r="8" />
        <circle className={styles.black} cx="1308.03" cy="136" r="8" />
        <circle className={styles.black} cx="20.03" cy="164" r="8" />
        <circle className={styles.black} cx="48.03" cy="164" r="8" />
        <circle className={styles.black} cx="104.03" cy="164" r="8" />
        <circle className={styles.black} cx="132.03" cy="164" r="8" />
        <circle className={styles.black} cx="160.03" cy="164" r="8" />
        <circle className={styles.black} cx="188.03" cy="164" r="8" />
        <circle className={styles.black} cx="216.03" cy="164" r="8" />
        <circle className={styles.black} cx="244.03" cy="164" r="8" />
        <circle className={styles.black} cx="328.03" cy="164" r="8" />
        <circle className={styles.black} cx="356.03" cy="164" r="8" />
        <circle className={styles.black} cx="384.03" cy="164" r="8" />
        <circle className={styles.black} cx="412.03" cy="164" r="8" />
        <circle className={styles.black} cx="440.03" cy="164" r="8" />
        <circle className={styles.black} cx="468.03" cy="164" r="8" />
        <circle className={styles.black} cx="496.03" cy="164" r="8" />
        <circle className={styles.black} cx="720.03" cy="164" r="8" />
        <circle className={styles.black} cx="748.03" cy="164" r="8" />
        <circle className={styles.black} cx="776.03" cy="164" r="8" />
        <circle className={styles.black} cx="916.03" cy="164" r="8" />
        <circle className={styles.black} cx="944.03" cy="164" r="8" />
        <circle className={styles.black} cx="1000.03" cy="164" r="8" />
        <circle className={styles.black} cx="1028.03" cy="164" r="8" />
        <circle className={styles.black} cx="1056.03" cy="164" r="8" />
        <circle className={styles.black} cx="1084.03" cy="164" r="8" />
        <circle className={styles.black} cx="1112.03" cy="164" r="8" />
        <circle className={styles.black} cx="1140.03" cy="164" r="8" />
        <circle className={styles.black} cx="1168.03" cy="164" r="8" />
        <circle className={styles.black} cx="1196.03" cy="164" r="8" />
        <circle className={styles.black} cx="1224.03" cy="164" r="8" />
        <circle className={styles.black} cx="1252.03" cy="164" r="8" />
        <circle className={styles.black} cx="1280.03" cy="164" r="8" />
        <circle className={styles.black} cx="1308.03" cy="164" r="8" />
        <circle className={styles.black} cx="1336.03" cy="164" r="8" />
        <circle className={styles.black} cx="1364.03" cy="164" r="8" />
        <circle className={styles.black} cx="20.03" cy="192" r="8" />
        <circle className={styles.black} cx="48.03" cy="192" r="8" />
        <circle className={styles.black} cx="76.03" cy="192" r="8" />
        <circle className={styles.black} cx="104.03" cy="192" r="8" />
        <circle className={styles.black} cx="132.03" cy="192" r="8" />
        <circle className={styles.black} cx="160.03" cy="192" r="8" />
        <circle className={styles.black} cx="216.03" cy="192" r="8" />
        <circle className={styles.black} cx="244.03" cy="192" r="8" />
        <circle className={styles.black} cx="272.03" cy="192" r="8" />
        <circle className={styles.black} cx="328.03" cy="192" r="8" />
        <circle className={styles.black} cx="356.03" cy="192" r="8" />
        <circle className={styles.black} cx="384.03" cy="192" r="8" />
        <circle className={styles.black} cx="412.03" cy="192" r="8" />
        <circle className={styles.black} cx="440.03" cy="192" r="8" />
        <circle className={styles.black} cx="692.03" cy="192" r="8" />
        <circle className={styles.black} cx="720.03" cy="192" r="8" />
        <circle className={styles.black} cx="748.03" cy="192" r="8" />
        <circle className={styles.black} cx="776.03" cy="192" r="8" />
        <circle className={styles.black} cx="804.03" cy="192" r="8" />
        <circle className={styles.black} cx="832.03" cy="192" r="8" />
        <circle className={styles.black} cx="860.03" cy="192" r="8" />
        <circle className={styles.black} cx="888.03" cy="192" r="8" />
        <circle className={styles.black} cx="916.03" cy="192" r="8" />
        <circle className={styles.black} cx="944.03" cy="192" r="8" />
        <circle className={styles.black} cx="972.03" cy="192" r="8" />
        <circle className={styles.black} cx="1000.03" cy="192" r="8" />
        <circle className={styles.black} cx="1028.03" cy="192" r="8" />
        <circle className={styles.black} cx="1056.03" cy="192" r="8" />
        <circle className={styles.black} cx="1084.03" cy="192" r="8" />
        <circle className={styles.black} cx="1112.03" cy="192" r="8" />
        <circle className={styles.black} cx="1140.03" cy="192" r="8" />
        <circle className={styles.black} cx="1168.03" cy="192" r="8" />
        <circle className={styles.black} cx="1196.03" cy="192" r="8" />
        <circle className={styles.black} cx="1224.03" cy="192" r="8" />
        <circle className={styles.black} cx="1252.03" cy="192" r="8" />
        <circle className={styles.black} cx="1280.03" cy="192" r="8" />
        <circle className={styles.black} cx="1308.03" cy="192" r="8" />
        <circle className={styles.black} cx="1336.03" cy="192" r="8" />
        <circle className={styles.black} cx="1364.03" cy="192" r="8" />
        <circle className={styles.black} cx="20.03" cy="220" r="8" />
        <circle className={styles.black} cx="48.03" cy="220" r="8" />
        <circle className={styles.black} cx="76.03" cy="220" r="8" />
        <circle className={styles.black} cx="104.03" cy="220" r="8" />
        <circle className={styles.black} cx="132.03" cy="220" r="8" />
        <circle className={styles.black} cx="160.03" cy="220" r="8" />
        <circle className={styles.black} cx="188.03" cy="220" r="8" />
        <circle className={styles.black} cx="216.03" cy="220" r="8" />
        <circle className={styles.black} cx="244.03" cy="220" r="8" />
        <circle className={styles.black} cx="328.03" cy="220" r="8" />
        <circle className={styles.black} cx="356.03" cy="220" r="8" />
        <circle className={styles.black} cx="384.03" cy="220" r="8" />
        <circle className={styles.black} cx="496.03" cy="220" r="8" />
        <circle className={styles.black} cx="524.03" cy="220" r="8" />
        <circle className={styles.black} cx="692.03" cy="220" r="8" />
        <circle className={styles.black} cx="776.03" cy="220" r="8" />
        <circle className={styles.black} cx="804.03" cy="220" r="8" />
        <circle className={styles.black} cx="832.03" cy="220" r="8" />
        <circle className={styles.black} cx="860.03" cy="220" r="8" />
        <circle className={styles.black} cx="888.03" cy="220" r="8" />
        <circle className={styles.black} cx="916.03" cy="220" r="8" />
        <circle className={styles.black} cx="944.03" cy="220" r="8" />
        <circle className={styles.black} cx="972.03" cy="220" r="8" />
        <circle className={styles.black} cx="1000.03" cy="220" r="8" />
        <circle className={styles.black} cx="1028.03" cy="220" r="8" />
        <circle className={styles.black} cx="1056.03" cy="220" r="8" />
        <circle className={styles.black} cx="1084.03" cy="220" r="8" />
        <circle className={styles.black} cx="1112.03" cy="220" r="8" />
        <circle className={styles.black} cx="1140.03" cy="220" r="8" />
        <circle className={styles.black} cx="1168.03" cy="220" r="8" />
        <circle className={styles.black} cx="1196.03" cy="220" r="8" />
        <circle className={styles.black} cx="1224.03" cy="220" r="8" />
        <circle className={styles.black} cx="1252.03" cy="220" r="8" />
        <circle className={styles.black} cx="1280.03" cy="220" r="8" />
        <circle className={styles.black} cx="1308.03" cy="220" r="8" />
        <circle className={styles.black} cx="1336.03" cy="220" r="8" />
        <circle className={styles.black} cx="1364.03" cy="220" r="8" />
        <circle className={styles.black} cx="20.03" cy="248" r="8" />
        <circle className={styles.black} cx="48.03" cy="248" r="8" />
        <circle className={styles.black} cx="76.03" cy="248" r="8" />
        <circle className={styles.black} cx="104.03" cy="248" r="8" />
        <circle className={styles.black} cx="188.03" cy="248" r="8" />
        <circle className={styles.black} cx="216.03" cy="248" r="8" />
        <circle className={styles.black} cx="356.03" cy="248" r="8" />
        <circle className={styles.black} cx="384.03" cy="248" r="8" />
        <circle className={styles.black} cx="664.03" cy="248" r="8" />
        <circle className={styles.black} cx="692.03" cy="248" r="8" />
        <circle className={styles.black} cx="748.03" cy="248" r="8" />
        <circle className={styles.black} cx="776.03" cy="248" r="8" />
        <circle className={styles.black} cx="804.03" cy="248" r="8" />
        <circle className={styles.black} cx="832.03" cy="248" r="8" />
        <circle className={styles.black} cx="860.03" cy="248" r="8" />
        <circle className={styles.black} cx="888.03" cy="248" r="8" />
        <circle className={styles.black} cx="916.03" cy="248" r="8" />
        <circle className={styles.black} cx="944.03" cy="248" r="8" />
        <circle className={styles.black} cx="972.03" cy="248" r="8" />
        <circle className={styles.black} cx="1000.03" cy="248" r="8" />
        <circle className={styles.black} cx="1028.03" cy="248" r="8" />
        <circle className={styles.black} cx="1056.03" cy="248" r="8" />
        <circle className={styles.black} cx="1084.03" cy="248" r="8" />
        <circle className={styles.black} cx="1112.03" cy="248" r="8" />
        <circle className={styles.black} cx="1140.03" cy="248" r="8" />
        <circle className={styles.black} cx="1168.03" cy="248" r="8" />
        <circle className={styles.black} cx="1196.03" cy="248" r="8" />
        <circle className={styles.black} cx="1224.03" cy="248" r="8" />
        <circle className={styles.black} cx="1252.03" cy="248" r="8" />
        <circle className={styles.black} cx="1280.03" cy="248" r="8" />
        <circle className={styles.black} cx="1308.03" cy="248" r="8" />
        <circle className={styles.black} cx="1336.03" cy="248" r="8" />
        <circle className={styles.black} cx="1364.03" cy="248" r="8" />
        <circle className={styles.black} cx="20.03" cy="276" r="8" />
        <circle className={styles.black} cx="48.03" cy="276" r="8" />
        <circle className={styles.black} cx="76.03" cy="276" r="8" />
        <circle className={styles.black} cx="104.03" cy="276" r="8" />
        <circle className={styles.black} cx="188.03" cy="276" r="8" />
        <circle className={styles.black} cx="216.03" cy="276" r="8" />
        <circle className={styles.black} cx="244.03" cy="276" r="8" />
        <circle className={styles.black} cx="272.03" cy="276" r="8" />
        <circle className={styles.black} cx="580.03" cy="276" r="8" />
        <circle className={styles.black} cx="608.03" cy="276" r="8" />
        <circle className={styles.black} cx="664.03" cy="276" r="8" />
        <circle className={styles.black} cx="692.03" cy="276" r="8" />
        <circle className={styles.black} cx="720.03" cy="276" r="8" />
        <circle className={styles.black} cx="748.03" cy="276" r="8" />
        <circle className={styles.black} cx="776.03" cy="276" r="8" />
        <circle className={styles.black} cx="804.03" cy="276" r="8" />
        <circle className={styles.black} cx="832.03" cy="276" r="8" />
        <circle className={styles.black} cx="860.03" cy="276" r="8" />
        <circle className={styles.black} cx="888.03" cy="276" r="8" />
        <circle className={styles.black} cx="916.03" cy="276" r="8" />
        <circle className={styles.black} cx="944.03" cy="276" r="8" />
        <circle className={styles.black} cx="972.03" cy="276" r="8" />
        <circle className={styles.black} cx="1000.03" cy="276" r="8" />
        <circle className={styles.black} cx="1028.03" cy="276" r="8" />
        <circle className={styles.black} cx="1056.03" cy="276" r="8" />
        <circle className={styles.black} cx="1084.03" cy="276" r="8" />
        <circle className={styles.black} cx="1112.03" cy="276" r="8" />
        <circle className={styles.black} cx="1140.03" cy="276" r="8" />
        <circle className={styles.black} cx="1168.03" cy="276" r="8" />
        <circle className={styles.black} cx="1196.03" cy="276" r="8" />
        <circle className={styles.black} cx="1224.03" cy="276" r="8" />
        <circle className={styles.black} cx="1252.03" cy="276" r="8" />
        <circle className={styles.black} cx="1280.03" cy="276" r="8" />
        <circle className={styles.black} cx="1308.03" cy="276" r="8" />
        <circle className={styles.black} cx="1336.03" cy="276" r="8" />
        <circle className={styles.black} cx="1364.03" cy="276" r="8" />
        <circle className={styles.black} cx="20.03" cy="304" r="8" />
        <circle className={styles.black} cx="48.03" cy="304" r="8" />
        <circle className={styles.black} cx="76.03" cy="304" r="8" />
        <circle className={styles.black} cx="104.03" cy="304" r="8" />
        <circle className={styles.black} cx="132.03" cy="304" r="8" />
        <circle className={styles.black} cx="160.03" cy="304" r="8" />
        <circle className={styles.black} cx="188.03" cy="304" r="8" />
        <circle className={styles.black} cx="216.03" cy="304" r="8" />
        <circle className={styles.black} cx="244.03" cy="304" r="8" />
        <circle className={styles.black} cx="272.03" cy="304" r="8" />
        <circle className={styles.black} cx="300.03" cy="304" r="8" />
        <circle className={styles.black} cx="580.03" cy="304" r="8" />
        <circle className={styles.black} cx="692.03" cy="304" r="8" />
        <circle className={styles.black} cx="720.03" cy="304" r="8" />
        <circle className={styles.black} cx="748.03" cy="304" r="8" />
        <circle className={styles.black} cx="776.03" cy="304" r="8" />
        <circle className={styles.black} cx="804.03" cy="304" r="8" />
        <circle className={styles.black} cx="832.03" cy="304" r="8" />
        <circle className={styles.black} cx="860.03" cy="304" r="8" />
        <circle className={styles.black} cx="888.03" cy="304" r="8" />
        <circle className={styles.black} cx="916.03" cy="304" r="8" />
        <circle className={styles.black} cx="944.03" cy="304" r="8" />
        <circle className={styles.black} cx="972.03" cy="304" r="8" />
        <circle className={styles.black} cx="1000.03" cy="304" r="8" />
        <circle className={styles.black} cx="1028.03" cy="304" r="8" />
        <circle className={styles.black} cx="1056.03" cy="304" r="8" />
        <circle className={styles.black} cx="1084.03" cy="304" r="8" />
        <circle className={styles.black} cx="1112.03" cy="304" r="8" />
        <circle className={styles.black} cx="1140.03" cy="304" r="8" />
        <circle className={styles.black} cx="1168.03" cy="304" r="8" />
        <circle className={styles.black} cx="1196.03" cy="304" r="8" />
        <circle className={styles.black} cx="1224.03" cy="304" r="8" />
        <circle className={styles.black} cx="1252.03" cy="304" r="8" />
        <circle className={styles.black} cx="1280.03" cy="304" r="8" />
        <circle className={styles.black} cx="1308.03" cy="304" r="8" />
        <circle className={styles.black} cx="1336.03" cy="304" r="8" />
        <circle className={styles.black} cx="20.03" cy="332" r="8" />
        <circle className={styles.black} cx="48.03" cy="332" r="8" />
        <circle className={styles.black} cx="76.03" cy="332" r="8" />
        <circle className={styles.black} cx="104.03" cy="332" r="8" />
        <circle className={styles.black} cx="132.03" cy="332" r="8" />
        <circle className={styles.black} cx="160.03" cy="332" r="8" />
        <circle className={styles.black} cx="188.03" cy="332" r="8" />
        <circle className={styles.black} cx="216.03" cy="332" r="8" />
        <circle className={styles.black} cx="244.03" cy="332" r="8" />
        <circle className={styles.black} cx="272.03" cy="332" r="8" />
        <circle className={styles.black} cx="300.03" cy="332" r="8" />
        <circle className={styles.black} cx="692.03" cy="332" r="8" />
        <circle className={styles.black} cx="720.03" cy="332" r="8" />
        <circle className={styles.black} cx="748.03" cy="332" r="8" />
        <circle className={styles.black} cx="776.03" cy="332" r="8" />
        <circle className={styles.black} cx="804.03" cy="332" r="8" />
        <circle className={styles.black} cx="832.03" cy="332" r="8" />
        <circle className={styles.black} cx="860.03" cy="332" r="8" />
        <circle className={styles.black} cx="888.03" cy="332" r="8" />
        <circle className={styles.black} cx="916.03" cy="332" r="8" />
        <circle className={styles.black} cx="944.03" cy="332" r="8" />
        <circle className={styles.black} cx="972.03" cy="332" r="8" />
        <circle className={styles.black} cx="1000.03" cy="332" r="8" />
        <circle className={styles.black} cx="1028.03" cy="332" r="8" />
        <circle className={styles.black} cx="1056.03" cy="332" r="8" />
        <circle className={styles.black} cx="1084.03" cy="332" r="8" />
        <circle className={styles.black} cx="1112.03" cy="332" r="8" />
        <circle className={styles.black} cx="1140.03" cy="332" r="8" />
        <circle className={styles.black} cx="1168.03" cy="332" r="8" />
        <circle className={styles.black} cx="1196.03" cy="332" r="8" />
        <circle className={styles.black} cx="1224.03" cy="332" r="8" />
        <circle className={styles.black} cx="1252.03" cy="332" r="8" />
        <circle className={styles.black} cx="1280.03" cy="332" r="8" />
        <circle className={styles.black} cx="1308.03" cy="332" r="8" />
        <circle className={styles.black} cx="1336.03" cy="332" r="8" />
        <circle className={styles.black} cx="1364.03" cy="332" r="8" />
        <circle className={styles.black} cx="20.03" cy="360" r="8" />
        <circle className={styles.black} cx="48.03" cy="360" r="8" />
        <circle className={styles.black} cx="76.03" cy="360" r="8" />
        <circle className={styles.black} cx="104.03" cy="360" r="8" />
        <circle className={styles.black} cx="132.03" cy="360" r="8" />
        <circle className={styles.black} cx="188.03" cy="360" r="8" />
        <circle className={styles.black} cx="216.03" cy="360" r="8" />
        <circle className={styles.black} cx="244.03" cy="360" r="8" />
        <circle className={styles.black} cx="328.03" cy="360" r="8" />
        <circle className={styles.black} cx="608.03" cy="360" r="8" />
        <circle className={styles.black} cx="636.03" cy="360" r="8" />
        <circle className={styles.black} cx="664.03" cy="360" r="8" />
        <circle className={styles.black} cx="692.03" cy="360" r="8" />
        <circle className={styles.black} cx="748.03" cy="360" r="8" />
        <circle className={styles.black} cx="776.03" cy="360" r="8" />
        <circle className={styles.black} cx="804.03" cy="360" r="8" />
        <circle className={styles.black} cx="832.03" cy="360" r="8" />
        <circle className={styles.black} cx="860.03" cy="360" r="8" />
        <circle className={styles.black} cx="888.03" cy="360" r="8" />
        <circle className={styles.black} cx="916.03" cy="360" r="8" />
        <circle className={styles.black} cx="944.03" cy="360" r="8" />
        <circle className={styles.black} cx="972.03" cy="360" r="8" />
        <circle className={styles.black} cx="1000.03" cy="360" r="8" />
        <circle className={styles.black} cx="1028.03" cy="360" r="8" />
        <circle className={styles.black} cx="1056.03" cy="360" r="8" />
        <circle className={styles.black} cx="1084.03" cy="360" r="8" />
        <circle className={styles.black} cx="1112.03" cy="360" r="8" />
        <circle className={styles.black} cx="1140.03" cy="360" r="8" />
        <circle className={styles.black} cx="1168.03" cy="360" r="8" />
        <circle className={styles.black} cx="1196.03" cy="360" r="8" />
        <circle className={styles.black} cx="1224.03" cy="360" r="8" />
        <circle className={styles.black} cx="1252.03" cy="360" r="8" />
        <circle className={styles.black} cx="1280.03" cy="360" r="8" />
        <circle className={styles.black} cx="1308.03" cy="360" r="8" />
        <circle className={styles.black} cx="1336.03" cy="360" r="8" />
        <circle className={styles.black} cx="1364.03" cy="360" r="8" />
        <circle className={styles.black} cx="20.03" cy="388" r="8" />
        <circle className={styles.black} cx="48.03" cy="388" r="8" />
        <circle className={styles.black} cx="76.03" cy="388" r="8" />
        <circle className={styles.black} cx="104.03" cy="388" r="8" />
        <circle className={styles.black} cx="132.03" cy="388" r="8" />
        <circle className={styles.black} cx="160.03" cy="388" r="8" />
        <circle className={styles.black} cx="188.03" cy="388" r="8" />
        <circle className={styles.black} cx="580.03" cy="388" r="8" />
        <circle className={styles.black} cx="608.03" cy="388" r="8" />
        <circle className={styles.black} cx="692.03" cy="388" r="8" />
        <circle className={styles.black} cx="720.03" cy="388" r="8" />
        <circle className={styles.black} cx="748.03" cy="388" r="8" />
        <circle className={styles.black} cx="860.03" cy="388" r="8" />
        <circle className={styles.black} cx="916.03" cy="388" r="8" />
        <circle className={styles.black} cx="944.03" cy="388" r="8" />
        <circle className={styles.black} cx="972.03" cy="388" r="8" />
        <circle className={styles.black} cx="1000.03" cy="388" r="8" />
        <circle className={styles.black} cx="1028.03" cy="388" r="8" />
        <circle className={styles.black} cx="1056.03" cy="388" r="8" />
        <circle className={styles.black} cx="1084.03" cy="388" r="8" />
        <circle className={styles.black} cx="1112.03" cy="388" r="8" />
        <circle className={styles.black} cx="1140.03" cy="388" r="8" />
        <circle className={styles.black} cx="1168.03" cy="388" r="8" />
        <circle className={styles.black} cx="1196.03" cy="388" r="8" />
        <circle className={styles.black} cx="1224.03" cy="388" r="8" />
        <circle className={styles.black} cx="1252.03" cy="388" r="8" />
        <circle className={styles.black} cx="1280.03" cy="388" r="8" />
        <circle className={styles.black} cx="1308.03" cy="388" r="8" />
        <circle className={styles.black} cx="1336.03" cy="388" r="8" />
        <circle className={styles.black} cx="20.03" cy="416" r="8" />
        <circle className={styles.black} cx="48.03" cy="416" r="8" />
        <circle className={styles.black} cx="76.03" cy="416" r="8" />
        <circle className={styles.black} cx="104.03" cy="416" r="8" />
        <circle className={styles.black} cx="132.03" cy="416" r="8" />
        <circle className={styles.black} cx="160.03" cy="416" r="8" />
        <circle className={styles.black} cx="580.03" cy="416" r="8" />
        <circle className={styles.black} cx="636.03" cy="416" r="8" />
        <circle className={styles.black} cx="664.03" cy="416" r="8" />
        <circle className={styles.black} cx="748.03" cy="416" r="8" />
        <circle className={styles.black} cx="776.03" cy="416" r="8" />
        <circle className={styles.black} cx="804.03" cy="416" r="8" />
        <circle className={styles.black} cx="832.03" cy="416" r="8" />
        <circle className={styles.black} cx="860.03" cy="416" r="8" />
        <circle className={styles.black} cx="916.03" cy="416" r="8" />
        <circle className={styles.black} cx="944.03" cy="416" r="8" />
        <circle className={styles.black} cx="972.03" cy="416" r="8" />
        <circle className={styles.black} cx="1000.03" cy="416" r="8" />
        <circle className={styles.black} cx="1028.03" cy="416" r="8" />
        <circle className={styles.black} cx="1056.03" cy="416" r="8" />
        <circle className={styles.black} cx="1084.03" cy="416" r="8" />
        <circle className={styles.black} cx="1112.03" cy="416" r="8" />
        <circle className={styles.black} cx="1140.03" cy="416" r="8" />
        <circle className={styles.black} cx="1168.03" cy="416" r="8" />
        <circle className={styles.black} cx="1196.03" cy="416" r="8" />
        <circle className={styles.black} cx="1224.03" cy="416" r="8" />
        <circle className={styles.black} cx="1252.03" cy="416" r="8" />
        <circle className={styles.black} cx="1280.03" cy="416" r="8" />
        <circle className={styles.black} cx="1308.03" cy="416" r="8" />
        <circle className={styles.black} cx="20.03" cy="444" r="8" />
        <circle className={styles.black} cx="48.03" cy="444" r="8" />
        <circle className={styles.black} cx="76.03" cy="444" r="8" />
        <circle className={styles.black} cx="104.03" cy="444" r="8" />
        <circle className={styles.black} cx="132.03" cy="444" r="8" />
        <circle className={styles.black} cx="160.03" cy="444" r="8" />
        <circle className={styles.black} cx="188.03" cy="444" r="8" />
        <circle className={styles.black} cx="608.03" cy="444" r="8" />
        <circle className={styles.black} cx="636.03" cy="444" r="8" />
        <circle className={styles.black} cx="664.03" cy="444" r="8" />
        <circle className={styles.black} cx="748.03" cy="444" r="8" />
        <circle className={styles.black} cx="832.03" cy="444" r="8" />
        <circle className={styles.black} cx="860.03" cy="444" r="8" />
        <circle className={styles.black} cx="888.03" cy="444" r="8" />
        <circle className={styles.black} cx="916.03" cy="444" r="8" />
        <circle className={styles.black} cx="972.03" cy="444" r="8" />
        <circle className={styles.black} cx="1000.03" cy="444" r="8" />
        <circle className={styles.black} cx="1028.03" cy="444" r="8" />
        <circle className={styles.black} cx="1056.03" cy="444" r="8" />
        <circle className={styles.black} cx="1084.03" cy="444" r="8" />
        <circle className={styles.black} cx="1112.03" cy="444" r="8" />
        <circle className={styles.black} cx="1140.03" cy="444" r="8" />
        <circle className={styles.black} cx="1168.03" cy="444" r="8" />
        <circle className={styles.black} cx="1196.03" cy="444" r="8" />
        <circle className={styles.black} cx="1224.03" cy="444" r="8" />
        <circle className={styles.black} cx="1252.03" cy="444" r="8" />
        <circle className={styles.black} cx="1308.03" cy="444" r="8" />
        <circle className={styles.black} cx="1336.03" cy="444" r="8" />
        <circle className={styles.black} cx="1364.03" cy="444" r="8" />
        <circle className={styles.black} cx="20.03" cy="472" r="8" />
        <circle className={styles.black} cx="48.03" cy="472" r="8" />
        <circle className={styles.black} cx="76.03" cy="472" r="8" />
        <circle className={styles.black} cx="104.03" cy="472" r="8" />
        <circle className={styles.black} cx="132.03" cy="472" r="8" />
        <circle className={styles.black} cx="160.03" cy="472" r="8" />
        <circle className={styles.black} cx="580.03" cy="472" r="8" />
        <circle className={styles.black} cx="608.03" cy="472" r="8" />
        <circle className={styles.black} cx="636.03" cy="472" r="8" />
        <circle className={styles.black} cx="664.03" cy="472" r="8" />
        <circle className={styles.black} cx="692.03" cy="472" r="8" />
        <circle className={styles.black} cx="720.03" cy="472" r="8" />
        <circle className={styles.black} cx="748.03" cy="472" r="8" />
        <circle className={styles.black} cx="776.03" cy="472" r="8" />
        <circle className={styles.black} cx="804.03" cy="472" r="8" />
        <circle className={styles.black} cx="832.03" cy="472" r="8" />
        <circle className={styles.black} cx="860.03" cy="472" r="8" />
        <circle className={styles.black} cx="888.03" cy="472" r="8" />
        <circle className={styles.black} cx="944.03" cy="472" r="8" />
        <circle className={styles.black} cx="972.03" cy="472" r="8" />
        <circle className={styles.black} cx="1000.03" cy="472" r="8" />
        <circle className={styles.black} cx="1028.03" cy="472" r="8" />
        <circle className={styles.black} cx="1056.03" cy="472" r="8" />
        <circle className={styles.black} cx="1084.03" cy="472" r="8" />
        <circle className={styles.black} cx="1112.03" cy="472" r="8" />
        <circle className={styles.black} cx="1140.03" cy="472" r="8" />
        <circle className={styles.black} cx="1168.03" cy="472" r="8" />
        <circle className={styles.black} cx="1196.03" cy="472" r="8" />
        <circle className={styles.black} cx="1224.03" cy="472" r="8" />
        <circle className={styles.black} cx="1252.03" cy="472" r="8" />
        <circle className={styles.black} cx="1280.03" cy="472" r="8" />
        <circle className={styles.black} cx="20.03" cy="500" r="8" />
        <circle className={styles.black} cx="48.03" cy="500" r="8" />
        <circle className={styles.black} cx="76.03" cy="500" r="8" />
        <circle className={styles.black} cx="188.03" cy="500" r="8" />
        <circle className={styles.black} cx="552.03" cy="500" r="8" />
        <circle className={styles.black} cx="580.03" cy="500" r="8" />
        <circle className={styles.black} cx="608.03" cy="500" r="8" />
        <circle className={styles.black} cx="636.03" cy="500" r="8" />
        <circle className={styles.black} cx="664.03" cy="500" r="8" />
        <circle className={styles.black} cx="692.03" cy="500" r="8" />
        <circle className={styles.black} cx="720.03" cy="500" r="8" />
        <circle className={styles.black} cx="748.03" cy="500" r="8" />
        <circle className={styles.black} cx="776.03" cy="500" r="8" />
        <circle className={styles.black} cx="804.03" cy="500" r="8" />
        <circle className={styles.black} cx="832.03" cy="500" r="8" />
        <circle className={styles.black} cx="860.03" cy="500" r="8" />
        <circle className={styles.black} cx="888.03" cy="500" r="8" />
        <circle className={styles.black} cx="916.03" cy="500" r="8" />
        <circle className={styles.black} cx="944.03" cy="500" r="8" />
        <circle className={styles.black} cx="972.03" cy="500" r="8" />
        <circle className={styles.black} cx="1000.03" cy="500" r="8" />
        <circle className={styles.black} cx="1028.03" cy="500" r="8" />
        <circle className={styles.black} cx="1056.03" cy="500" r="8" />
        <circle className={styles.black} cx="1084.03" cy="500" r="8" />
        <circle className={styles.black} cx="1112.03" cy="500" r="8" />
        <circle className={styles.black} cx="1140.03" cy="500" r="8" />
        <circle className={styles.black} cx="1168.03" cy="500" r="8" />
        <circle className={styles.black} cx="1196.03" cy="500" r="8" />

        <circle className={styles.black} cx="1252.03" cy="500" r="8" />
        <circle className={styles.black} cx="1280.03" cy="500" r="8" />
        <circle className={styles.black} cx="48.03" cy="528" r="8" />
        <circle className={styles.black} cx="76.03" cy="528" r="8" />
        <circle className={styles.black} cx="132.03" cy="528" r="8" />
        <circle className={styles.black} cx="188.03" cy="528" r="8" />
        <circle className={styles.black} cx="216.03" cy="528" r="8" />
        <circle className={styles.black} cx="524.03" cy="528" r="8" />
        <circle className={styles.black} cx="552.03" cy="528" r="8" />
        <circle className={styles.black} cx="580.03" cy="528" r="8" />
        <circle className={styles.black} cx="608.03" cy="528" r="8" />
        <circle className={styles.black} cx="636.03" cy="528" r="8" />
        <circle className={styles.black} cx="664.03" cy="528" r="8" />
        <circle className={styles.black} cx="692.03" cy="528" r="8" />
        <circle className={styles.black} cx="720.03" cy="528" r="8" />
        <circle className={styles.black} cx="748.03" cy="528" r="8" />
        <circle className={styles.black} cx="776.03" cy="528" r="8" />
        <circle className={styles.black} cx="804.03" cy="528" r="8" />
        <circle className={styles.black} cx="832.03" cy="528" r="8" />
        <circle className={styles.black} cx="860.03" cy="528" r="8" />
        <circle className={styles.black} cx="888.03" cy="528" r="8" />
        <circle className={styles.black} cx="916.03" cy="528" r="8" />
        <circle className={styles.black} cx="1000.03" cy="528" r="8" />
        <circle className={styles.black} cx="1028.03" cy="528" r="8" />
        <circle className={styles.black} cx="1056.03" cy="528" r="8" />
        <circle className={styles.black} cx="1084.03" cy="528" r="8" />
        <circle className={styles.black} cx="1140.03" cy="528" r="8" />
        <circle className={styles.black} cx="1168.03" cy="528" r="8" />
        <circle className={styles.black} cx="1196.03" cy="528" r="8" />
        <circle className={styles.black} cx="76.03" cy="556" r="8" />
        <circle className={styles.black} cx="104.03" cy="556" r="8" />
        <circle className={styles.black} cx="132.03" cy="556" r="8" />
        <circle className={styles.black} cx="160.03" cy="556" r="8" />
        <circle className={styles.black} cx="524.03" cy="556" r="8" />
        <circle className={styles.black} cx="552.03" cy="556" r="8" />
        <circle className={styles.black} cx="580.03" cy="556" r="8" />
        <circle className={styles.black} cx="608.03" cy="556" r="8" />
        <circle className={styles.black} cx="636.03" cy="556" r="8" />
        <circle className={styles.black} cx="664.03" cy="556" r="8" />
        <circle className={styles.black} cx="692.03" cy="556" r="8" />
        <circle className={styles.black} cx="720.03" cy="556" r="8" />
        <circle className={styles.black} cx="748.03" cy="556" r="8" />
        <circle className={styles.black} cx="776.03" cy="556" r="8" />
        <circle className={styles.black} cx="804.03" cy="556" r="8" />
        <circle className={styles.black} cx="832.03" cy="556" r="8" />
        <circle className={styles.black} cx="860.03" cy="556" r="8" />
        <circle className={styles.black} cx="888.03" cy="556" r="8" />
        <circle className={styles.black} cx="1028.03" cy="556" r="8" />
        <circle className={styles.black} cx="1056.03" cy="556" r="8" />
        <circle className={styles.black} cx="1140.03" cy="556" r="8" />
        <circle className={styles.black} cx="1168.03" cy="556" r="8" />
        <circle className={styles.black} cx="1196.03" cy="556" r="8" />
        <circle className={styles.black} cx="1280.03" cy="556" r="8" />
        <circle className={styles.black} cx="160.03" cy="584" r="8" />
        <circle className={styles.black} cx="216.03" cy="584" r="8" />
        <circle className={styles.black} cx="244.03" cy="584" r="8" />
        <circle className={styles.black} cx="272.03" cy="584" r="8" />
        <circle className={styles.black} cx="552.03" cy="584" r="8" />
        <circle className={styles.black} cx="580.03" cy="584" r="8" />
        <circle className={styles.black} cx="608.03" cy="584" r="8" />
        <circle className={styles.black} cx="636.03" cy="584" r="8" />
        <circle className={styles.black} cx="664.03" cy="584" r="8" />
        <circle className={styles.black} cx="692.03" cy="584" r="8" />
        <circle className={styles.black} cx="720.03" cy="584" r="8" />
        <circle className={styles.black} cx="748.03" cy="584" r="8" />
        <circle className={styles.black} cx="776.03" cy="584" r="8" />
        <circle className={styles.black} cx="804.03" cy="584" r="8" />
        <circle className={styles.black} cx="832.03" cy="584" r="8" />
        <circle className={styles.black} cx="860.03" cy="584" r="8" />
        <circle className={styles.black} cx="888.03" cy="584" r="8" />
        <circle className={styles.black} cx="1196.03" cy="584" r="8" />
        <circle className={styles.black} cx="1280.03" cy="584" r="8" />
        <circle className={styles.black} cx="216.03" cy="612" r="8" />
        <circle className={styles.black} cx="244.03" cy="612" r="8" />
        <circle className={styles.black} cx="272.03" cy="612" r="8" />
        <circle className={styles.black} cx="300.03" cy="612" r="8" />
        <circle className={styles.black} cx="328.03" cy="612" r="8" />
        <circle className={styles.black} cx="580.03" cy="612" r="8" />
        <circle className={styles.black} cx="608.03" cy="612" r="8" />
        <circle className={styles.black} cx="664.03" cy="612" r="8" />
        <circle className={styles.black} cx="692.03" cy="612" r="8" />
        <circle className={styles.black} cx="720.03" cy="612" r="8" />
        <circle className={styles.black} cx="748.03" cy="612" r="8" />
        <circle className={styles.black} cx="776.03" cy="612" r="8" />
        <circle className={styles.black} cx="804.03" cy="612" r="8" />
        <circle className={styles.black} cx="832.03" cy="612" r="8" />
        <circle className={styles.black} cx="860.03" cy="612" r="8" />
        <circle className={styles.black} cx="1056.03" cy="612" r="8" />
        <circle className={styles.black} cx="1140.03" cy="612" r="8" />
        <circle className={styles.black} cx="1168.03" cy="612" r="8" />
        <circle className={styles.black} cx="1252.03" cy="612" r="8" />
        <circle className={styles.black} cx="188.03" cy="640" r="8" />
        <circle className={styles.black} cx="216.03" cy="640" r="8" />
        <circle className={styles.black} cx="244.03" cy="640" r="8" />
        <circle className={styles.black} cx="272.03" cy="640" r="8" />
        <circle className={styles.black} cx="300.03" cy="640" r="8" />
        <circle className={styles.black} cx="328.03" cy="640" r="8" />
        <circle className={styles.black} cx="692.03" cy="640" r="8" />
        <circle className={styles.black} cx="720.03" cy="640" r="8" />
        <circle className={styles.black} cx="748.03" cy="640" r="8" />
        <circle className={styles.black} cx="776.03" cy="640" r="8" />
        <circle className={styles.black} cx="804.03" cy="640" r="8" />
        <circle className={styles.black} cx="832.03" cy="640" r="8" />
        <circle className={styles.black} cx="1168.03" cy="640" r="8" />
        <circle className={styles.black} cx="1224.03" cy="640" r="8" />
        <circle className={styles.black} cx="1252.03" cy="640" r="8" />
        <circle className={styles.black} cx="1280.03" cy="640" r="8" />
        <circle className={styles.black} cx="1308.03" cy="640" r="8" />
        <circle className={styles.black} cx="188.03" cy="668" r="8" />
        <circle className={styles.black} cx="216.03" cy="668" r="8" />
        <circle className={styles.black} cx="244.03" cy="668" r="8" />
        <circle className={styles.black} cx="272.03" cy="668" r="8" />
        <circle className={styles.black} cx="300.03" cy="668" r="8" />
        <circle className={styles.black} cx="328.03" cy="668" r="8" />
        <circle className={styles.black} cx="356.03" cy="668" r="8" />
        <circle className={styles.black} cx="384.03" cy="668" r="8" />
        <circle className={styles.black} cx="412.03" cy="668" r="8" />
        <circle className={styles.black} cx="692.03" cy="668" r="8" />
        <circle className={styles.black} cx="720.03" cy="668" r="8" />
        <circle className={styles.black} cx="748.03" cy="668" r="8" />
        <circle className={styles.black} cx="776.03" cy="668" r="8" />
        <circle className={styles.black} cx="804.03" cy="668" r="8" />
        <circle className={styles.black} cx="832.03" cy="668" r="8" />
        <circle className={styles.black} cx="1168.03" cy="668" r="8" />
        <circle className={styles.black} cx="1280.03" cy="668" r="8" />
        <circle className={styles.black} cx="1364.03" cy="668" r="8" />
        <circle className={styles.black} cx="188.03" cy="696" r="8" />
        <circle className={styles.black} cx="216.03" cy="696" r="8" />
        <circle className={styles.black} cx="244.03" cy="696" r="8" />
        <circle className={styles.black} cx="272.03" cy="696" r="8" />
        <circle className={styles.black} cx="300.03" cy="696" r="8" />
        <circle className={styles.black} cx="328.03" cy="696" r="8" />
        <circle className={styles.black} cx="356.03" cy="696" r="8" />
        <circle className={styles.black} cx="384.03" cy="696" r="8" />
        <circle className={styles.black} cx="412.03" cy="696" r="8" />
        <circle className={styles.black} cx="692.03" cy="696" r="8" />
        <circle className={styles.black} cx="720.03" cy="696" r="8" />
        <circle className={styles.black} cx="748.03" cy="696" r="8" />
        <circle className={styles.black} cx="776.03" cy="696" r="8" />
        <circle className={styles.black} cx="804.03" cy="696" r="8" />
        <circle className={styles.black} cx="832.03" cy="696" r="8" />
        <circle className={styles.black} cx="1252.03" cy="696" r="8" />
        <circle className={styles.black} cx="216.03" cy="724" r="8" />
        <circle className={styles.black} cx="244.03" cy="724" r="8" />
        <circle className={styles.black} cx="272.03" cy="724" r="8" />
        <circle className={styles.black} cx="300.03" cy="724" r="8" />
        <circle className={styles.black} cx="328.03" cy="724" r="8" />
        <circle className={styles.black} cx="356.03" cy="724" r="8" />
        <circle className={styles.black} cx="384.03" cy="724" r="8" />
        <circle className={styles.black} cx="692.03" cy="724" r="8" />
        <circle className={styles.black} cx="720.03" cy="724" r="8" />
        <circle className={styles.black} cx="748.03" cy="724" r="8" />
        <circle className={styles.black} cx="776.03" cy="724" r="8" />
        <circle className={styles.black} cx="804.03" cy="724" r="8" />
        <circle className={styles.black} cx="832.03" cy="724" r="8" />
        <circle className={styles.black} cx="888.03" cy="724" r="8" />
        <circle className={styles.black} cx="1308.03" cy="724" r="8" />
        <circle className={styles.black} cx="1336.03" cy="724" r="8" />
        <circle className={styles.black} cx="244.03" cy="752" r="8" />
        <circle className={styles.black} cx="272.03" cy="752" r="8" />
        <circle className={styles.black} cx="300.03" cy="752" r="8" />
        <circle className={styles.black} cx="328.03" cy="752" r="8" />
        <circle className={styles.black} cx="356.03" cy="752" r="8" />
        <circle className={styles.black} cx="384.03" cy="752" r="8" />
        <circle className={styles.black} cx="692.03" cy="752" r="8" />
        <circle className={styles.black} cx="720.03" cy="752" r="8" />
        <circle className={styles.black} cx="748.03" cy="752" r="8" />
        <circle className={styles.black} cx="776.03" cy="752" r="8" />
        <circle className={styles.black} cx="804.03" cy="752" r="8" />
        <circle className={styles.black} cx="860.03" cy="752" r="8" />
        <circle className={styles.black} cx="1280.03" cy="752" r="8" />
        <circle className={styles.black} cx="1308.03" cy="752" r="8" />
        <circle className={styles.black} cx="1336.03" cy="752" r="8" />
        <circle className={styles.black} cx="1364.03" cy="752" r="8" />
        <circle className={styles.black} cx="244.03" cy="780" r="8" />
        <circle className={styles.black} cx="272.03" cy="780" r="8" />
        <circle className={styles.black} cx="300.03" cy="780" r="8" />
        <circle className={styles.black} cx="328.03" cy="780" r="8" />
        <circle className={styles.black} cx="356.03" cy="780" r="8" />
        <circle className={styles.black} cx="720.03" cy="780" r="8" />
        <circle className={styles.black} cx="748.03" cy="780" r="8" />
        <circle className={styles.black} cx="776.03" cy="780" r="8" />
        <circle className={styles.black} cx="804.03" cy="780" r="8" />
        <circle className={styles.black} cx="860.03" cy="780" r="8" />
        <circle className={styles.black} cx="1224.03" cy="780" r="8" />
        <circle className={styles.black} cx="1252.03" cy="780" r="8" />
        <circle className={styles.black} cx="1280.03" cy="780" r="8" />
        <circle className={styles.black} cx="1308.03" cy="780" r="8" />
        <circle className={styles.black} cx="1336.03" cy="780" r="8" />
        <circle className={styles.black} cx="1364.03" cy="780" r="8" />
        <circle className={styles.black} cx="244.03" cy="808" r="8" />
        <circle className={styles.black} cx="272.03" cy="808" r="8" />
        <circle className={styles.black} cx="300.03" cy="808" r="8" />
        <circle className={styles.black} cx="328.03" cy="808" r="8" />
        <circle className={styles.black} cx="720.03" cy="808" r="8" />
        <circle className={styles.black} cx="748.03" cy="808" r="8" />
        <circle className={styles.black} cx="776.03" cy="808" r="8" />
        <circle className={styles.black} cx="1252.03" cy="808" r="8" />
        <circle className={styles.black} cx="1280.03" cy="808" r="8" />
        <circle className={styles.black} cx="1308.03" cy="808" r="8" />
        <circle className={styles.black} cx="1336.03" cy="808" r="8" />
        <circle className={styles.black} cx="1364.03" cy="808" r="8" />
        <circle className={styles.black} cx="244.03" cy="836" r="8" />
        <circle className={styles.black} cx="272.03" cy="836" r="8" />
        <circle className={styles.black} cx="300.03" cy="836" r="8" />
        <circle className={styles.black} cx="328.03" cy="836" r="8" />
        <circle className={styles.black} cx="720.03" cy="836" r="8" />
        <circle className={styles.black} cx="748.03" cy="836" r="8" />
        <circle className={styles.black} cx="1252.03" cy="836" r="8" />
        <circle className={styles.black} cx="1280.03" cy="836" r="8" />
        <circle className={styles.black} cx="1364.03" cy="836" r="8" />
        <circle className={styles.black} cx="216.03" cy="864" r="8" />
        <circle className={styles.black} cx="244.03" cy="864" r="8" />
        <circle className={styles.black} cx="272.03" cy="864" r="8" />
        <circle className={styles.black} cx="300.03" cy="864" r="8" />
        <circle className={styles.black} cx="216.03" cy="892" r="8" />
        <circle className={styles.black} cx="244.03" cy="892" r="8" />
        <circle className={styles.black} cx="216.03" cy="920" r="8" />
        <circle className={styles.black} cx="244.03" cy="920" r="8" />
        <circle className={styles.black} cx="216.03" cy="948" r="8" />
        <circle className={styles.black} cx="244.03" cy="948" r="8" />
        <circle className={styles.black} cx="216.03" cy="976" r="8" />
        <circle className={styles.black} cx="244.03" cy="976" r="8" />
      </g>
      <g ref={greenDots}>
        <circle className={styles.green} cx="720.03" cy="220" r="8" />
        <circle className={styles.green} cx="608.03" cy="304" r="8" />
        <circle className={styles.green} cx="608.03" cy="332" r="8" />
        <circle className={styles.green} cx="636.03" cy="332" r="8" />
        <circle className={styles.green} cx="664.03" cy="332" r="8" />
        <circle className={styles.green} cx="160.03" cy="360" r="8" />
        <circle className={styles.green} cx="720.03" cy="360" r="8" />
        <circle className={styles.green} cx="216.03" cy="388" r="8" />
        <circle className={styles.green} cx="636.03" cy="388" r="8" />
        <circle className={styles.green} cx="188.03" cy="416" r="8" />
        <circle className={styles.green} cx="608.03" cy="416" r="8" />
        <circle className={styles.green} cx="944.03" cy="444" r="8" />
        <circle className={styles.green} cx="916.03" cy="472" r="8" />
        <circle className={styles.green} cx="1224.03" cy="500" r="8" />
      </g>
    </svg>
  );
};

export default AnimatedMapMobile;
